import {
  generateArchiveUrl,
  getRegions as getRegionsAPI,
} from "../../utils/api";
import { Status } from "../../models/Status";
import { createAction } from "../../models/Action";
import * as T from "./types";
import ReactGA from "react-ga"; // React Google Analytics

export const downloadFile =
  (file: string, region: string, project: "nuScenes" | "nuPlan") =>
  async (dispatch) => {
    dispatch(createAction(T.DOWNLOAD_STATUS, Status.createLoading()));
    dispatch(createAction(T.DOWNLOAD_FILES_QUEUE, file));
    dispatch(createAction(T.DOWNLOAD_ING_REGION, region));

    try {
      const res = await generateArchiveUrl(file, region, project);
      dispatch(createAction(T.DOWNLOAD_FILES_UNQUEUE, file));
      dispatch(createAction(T.DOWNLOAD_ING_REGION, ""));
      dispatch(createAction(T.DOWNLOAD_STATUS, Status.createSuccess()));
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.location.href = res.url;
      ReactGA.event({
        category: "Download File",
        action: file,
      });
    } catch (e) {
      dispatch(createAction(T.DOWNLOAD_FILES_UNQUEUE, file));
      dispatch(createAction(T.DOWNLOAD_ING_REGION, ""));
      dispatch(createAction(T.DOWNLOAD_STATUS, Status.createFailed()));
    }
  };

export const getRegions = () => async (dispatch) => {
  try {
    const regions = await getRegionsAPI();
    dispatch(createAction(T.DOWNLOAD_GET_REGIONS, regions));
  } catch (e) {
    console.log(e);
  }
};
